/* eslint-disable max-len */
export const PRODUCT_DETAILS_CONSTANTS = {
    DunsManager: {
        appId: '154',
        productId: '14624',
        productShortName: 'Duns Manager',
        productName: 'D-U-N-S<sup>&reg;</sup> Manager'
    },
    DunsProfileManager: {
        appId: '154',
        productId: '14624',
        productShortName: 'Duns Profile Manager',
        productName: 'D-U-N-S<sup>&reg;</sup> Profile Manager'
    },
    ZETA: {
        appId: '253',
        productId: '17',
        productShortName: 'ZETA',
        productFullName: 'D&B Rev.Up Now'
    },
    SSVI: {
        appId: '231',
        productId: '15',
        productShortName: 'SSVI',
        productName: 'D&B Rev.Up ABX for Web Essential'
    },
    AnalyticsSTDTrial: {
        appId: '216',
        productId: '216',
        productShortName: 'Studio Trail',
        productName: 'Analytics STD Trial',
    },
    EBDashboard: {
        appId: '154',
        productId: '154',
        productShortName: 'EB Dashboard',
        productName: 'EB Dashboard',
    },
    FinanceAnalytics: {
        appId: '179',
        productId: '8',
        productShortName: 'DNBI FA',
        productName: 'D&B Finance Analytics',
    },
    Hoovers: {
        appId: '27',
        productId: '13',
        productShortName: 'Hoovers',
        productName: 'Hoovers',
    },
    SBS: {
        appId: '154',
        productId: '154',
        productShortName: 'SBS',
        productName: 'Small Business Solutions',
    },
    CIUKIFree: {
        appId: 294,
        productId: '14706',
        productShortName: 'CIUKIFree',
        productName: 'Credit Insights Free'
    },
    CreditMonitorUKI: {
        appId: '252',
        productId: '14176',
        productShortName: 'Credit Monitor',
        productName: 'Credit Monitor'
    },
    NavigateCredit: {
        appId: '294',
        productId: '27',
        productShortName: 'Credit Insights',
        productName: 'Credit Insights'
    },
    DunsRegisteredSeal: {
        appId: '274',
        productId: '28',
        productShortName: 'DRS',
        productName: 'D-U-N-S<sup>&reg;</sup> Registered<sup>&trade;</sup> Seal'
    },
    CreditInsights: {
        appId: '294',
        productId: '27',
        productShortName: 'Credit Insight',
        productName: 'Credit Insights'
    },
    CreditInsightsFree: {
        appId: '14706',
        productId: 14706,
        productShortName: 'CI',
        productName: 'Credit Insights Free'
    },
    CreditInsightsAssociateDUNS: {
        appId: '283',
        productId: 283,
        productShortName: 'CI',
        productName: 'Credit Insights Free',
        flowType: 'Associate-a-DUNS'
    },
    Livelogo: {
        appId: '288',
        productId: '24',
        productShortName: 'Livelogo',
        productName: 'Livelogo'
    },
    AAADiploma: {
        appId: '306',
        productId: '31',
        productShortName: 'AAA Diploma',
        productName: 'AAA Diploma'
    }
};

export const entitlementProductsDescriptionInfo = [
    {
        title: 'D-U-N-S<sup>&reg;</sup> Application',
        description: 'Your application for a D-U-N-S Number has been submitted and can take up to 30 business days to process.'
    },
    {
        title: 'D-U-N-S<sup>&reg;</sup> Manager',
        description: 'Update your Dun & Bradstreet<sup>&reg;</sup> business information for free',
    },
    {
        title: 'CreditBuilder<sup>&trade;</sup>',
        description: 'Monitor and potentially build your Dun & Bradstreet credit file',
    },
    {
        title: 'CreditSignal<sup>&reg;</sup>',
        description: "Unlimited access to view changes to four of your company's D&B® scores and ratings",
    },
    {
        title: 'CreditSignal Plus<sup>&reg;</sup>',
        description: 'View five business credit scores and ratings and receive email alerts to changes',
    },
    {
        title: 'CreditMonitor<sup>&trade;</sup>',
        description: 'Monitor the information in your D&B® business credit file, including your scores and ratings',
    },
    {
        title: 'D&B Business Listing',
        description: 'Add additional information to your Company Profile on the D&B® Business Directory',
    },
    {
        title: 'Business Credit Platform',
        description: "View a company's D&B® business credit file to help assess creditworthiness and risk level",
    },
    {
        title: 'D-U-N-S<sup>&reg;</sup> Registered<sup>&trade;</sup> Seal',
        description: 'Access your D-U-N-S® Registered Seal to show others that your company has been assigned a Dun & Bradstreet D-U-N-S Number.',
    },
    {
        title: 'D&B Business Launch Program',
        description: 'Access the products included in your D&B Business Launch product bundle once your company has been assigned a Dun & Bradstreet D-U-N-S® Number.',
    },
    {
        title: 'D&B Business Launch Program Lite',
        description: 'Access the products included in your D&B Business Launch product bundle once your company has been assigned a Dun & Bradstreet D-U-N-S® Number.',
    },
    {
        title: 'DUNSFile<sup>&trade;</sup>',
        description: 'Expedited D&B D-U-N-S<sup>&reg;</sup> Number and basic business credit file creation',
    },
    {
        title: 'Credit Insights Free',
        description: 'Unlimited access to view your business credit file',
    },
    {
        title: 'Credit Insights Basic',
        description: 'Advanced monitoring of your business credit file'
    },
    {
        title: 'Credit Insights Unlock Scores',
        description: "View and monitor your business's actual PAYDEX®, Failure Score, and Delinquency Score",
    },
    {
        title: 'D&B Concierge Service - Product Access',
        description: 'Potentially impact your business credit file and advanced monitoring of your business credit file with unlimited submissions and acceptances.',
    },
];

// international product list

export const INTERNATIONAL_PRODUCT_LIST = {
    'D&B Finance Analytics': 'FA',
    Livelogo: 'AAA',
    'D&B Hoovers': 'HE'
};

export const VBO_PRODUCT_LIST_WITHOUT_DUNS = [
    'D&B Finance Analytics',
    'Livelogo',
    'AAA Diploma'
];

export const GAD_FLOW_PRODUCT_ID = 14707; // Credit Insights free

export const VBO_PRODUCTS = ['D&B Finance Analytics', 'Hoovers', 'AAA Livelogo', 'AAA Diploma', 'Hoovers Now'];

export const PRODUCT_TITLES_CI_UKI = {
    CREDIT_INSIGHTS_BASIC: 'Credit Insights Basic',
    CREDIT_INSIGHTS_FREE: 'Credit Insights Free',
};

export const creditSignalMigrationFAQUrl = 'https://www.dnb.com/content/dam/english/dnb-solutions/CS-CIFree_FAQ.pdf?utm_source=bloomreach&utm_campaign=SENT%3A%20Cohort%201%2C%20Week%201%2C%20Email%201%20-%20CS%20to%20CI%20Free&utm_medium=email';

export const myDNbUrl = 'https://my.dnb.com/';

export const PRODUCTS_OPEN_SAME_TAB = ['Credit Insights', 'D-U-N-S<sup>&reg;</sup> Profile Manager', 'D&B Business Listing'];
